import React from 'react'

export default function Footer() {
    return (
        <div className="footer">
            <h3>Made with love</h3>
        </div>
    )
}
